module.exports = __webpack_public_path__ + "fonts/PlusJakartaSans-SemiBold.03a280e1.ttf";